import React from 'react';
import './ComingSoon.scss';
import Hoverable from '../../blocks/Hoverable';
import useLanguage from '../../languages/useLanguage';
import useSetLanguage from '../../languages/useSetLanguage';
import BorderedImage from '../../blocks/BorderedImage';

function ComingSoon() {
  const language = useLanguage();
  const setLanguage = useSetLanguage();

  function handleEnglishClick() {
    setLanguage('English');
  }

  function handleFrenchClick() {
    setLanguage('French');
  }

  return (
    <div className="coming-soon-page">
      <div className="text-content">
        {/* insert logo */}
        <div className="align-center banner">
          <h1 className="title">{language.websiteTitle}</h1>
          <h2 className="subtitle paragraph-space">
            {language.comingSoonSubtitle}
            <Hoverable onClick={handleEnglishClick} space="before">
              English
            </Hoverable>
            -<Hoverable onClick={handleFrenchClick}>Français</Hoverable>
          </h2>
        </div>
        <div className="align-center">
          <h3 className="coming-soon">{language.comingSoonText}</h3>
          <p className="body">{language.comingSoonBody1}</p>
          <p className="body">{language.comingSoonBody2}</p>
          <p className="body paragraph-space">{language.comingSoonWorkWithMe}</p>
          <p className="body">
            {language.comingSoonGetInTouch}
            <Hoverable space="before">hello@akimi.space</Hoverable>
            {language.comingSoonGetInTouch2}
          </p>
          <p className="body">
            {language.comingSoonCallMe}
            <Hoverable space="before">+31 6 15083613</Hoverable>.
          </p>
        </div>
      </div>
      <div className="image-content">
        <BorderedImage borderColor="#a49a69" image="/images/portrait-05.png" />
      </div>
    </div>
  );
}

export default ComingSoon;
